import React from 'react';
import { Controller } from "react-hook-form";
// import Select from 'react-select'
import CustomReactSelect from 'components/Store/CustomReactSelect';
// import {Editor, EditorState} from 'draft-js';
import TextEditor from 'components/TextEditor'
// import RichTextEditor from 'react-rte';
// import Form from 'react-bootstrap/Form';

function FormGroup({ innerHtml, type, name, label, sublabel, placeholder, register, prepending, disabled, ...otherProps}) {

    const {select, options, control, updateOptions, onClick} = otherProps
    const {error} = otherProps
    const {getValues, setValue} = otherProps

    const {small} = otherProps
    const {textarea, texteditor} = otherProps

    const invalidStyle = {width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}

    const {fullSize} = otherProps;
    const {vertical} = otherProps
    var leftCol = fullSize ? "col-md-3" : "col-md-2"
    var rightCol = fullSize ? "col-md-9" : "col-md-6"

    if (vertical) {
        leftCol = ""
        rightCol = ""
    }

    var content;
    if (select && options) {
        content = (
        
        <div className={`${rightCol} input-group`}>
            <div style={{width: small ? "50%" : "100%"}}>
                <Controller
                    // as={<Select isDisabled={disabled}/>}
                    as={CustomReactSelect}
                    options={options}
                    control={control}
                    setValue={otherProps.setValue}
                    getValues={otherProps.getValues}
                    placeholder={placeholder}
                    // rules={{ required: true }}
                    // onChange={([selected]) => {
                    //     // React Select return object instead of value for selection
                    //     // return selected.value 
                    //     otherProps.onSelect(selected)
                    //     return selected
                    //     // return { value: selected };
                    // }}
                    name={name}
                    isMulti={otherProps.isMulti}
                    updateOptions={updateOptions}
                    {...otherProps}
                />
            </div>
            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
        </div>
        )
    } else if (texteditor) {
        content = (
            <div className={`${rightCol} input-group`}>

                <Controller
                    as={TextEditor}
                    control={control}
                    setValue={otherProps.setValue}
                    getValues={otherProps.getValues}
                    name={name}
                />

            </div>
        )

    } else if (textarea) {
        content = (
            <div className={`${rightCol} input-group`}>
                <textarea disabled={disabled} ref={register} rows="8" type="textarea" placeholder={placeholder} name={name} className="form-control" />
                {error && (
                    <div style={invalidStyle}>
                        {error.message}
                    </div>
                )}
            </div>
        )
    } else if (type === "checkbox") {
        content = (
        <div className={`${rightCol} d-flex mb-2`}>
            <input style={{width: "30px", height: "30px"}} onClick={onClick} id={name} disabled={disabled} ref={register} type={type} name={name} className={"mr-3 form-control" + (error ? " custom-invalid" : "")} />
            {placeholder && (
                <label htmlFor={name}>{placeholder}</label>
            )}
            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
        </div>
        )
    } else if (type === "hours") {
        content = (
        <div className={`col-md-3 input-group mb-2`}>
            {/* {(prepending && prepending.length > 0) && (
                
            )} */}
            <input disabled={disabled} ref={register} type="number" placeholder={placeholder} name={name} className={"form-control" + (error ? " custom-invalid" : "")} />
            <div className="input-group-append d-block">
                <div className="input-group-text">hours</div>
            </div>
            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
        </div>
        )
    } else if (type === "percentage") {
        content = (
        <div className={`col-md-3 input-group mb-2`}>
            <input disabled={disabled} ref={register} step={0.001} type="number" placeholder={placeholder} name={name} className={"form-control" + (error ? " custom-invalid" : "")} />
            <div className="input-group-append d-block">
                <div className="input-group-text">%</div>
            </div>
            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
        </div>
        )
    } else {
        content = (
        <div className={`${rightCol} input-group mb-2`}>
            {(prepending && prepending.length > 0) && (
                <div className="input-group-prepend d-block">
                    {prepending.map((val, idx) => {
                        return (
                            <div key={idx} className="input-group-text">{val}</div>
                        )
                    })}
                </div>
            )}
            <input disabled={disabled} ref={register} type={type} step={type === 'number' ? 0.01 : null} placeholder={placeholder} name={name} className={"form-control" + (error ? " custom-invalid" : "")} />
            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
        </div>
        )
    }

    return (<div className={`form-group ${vertical ? "" : "row"}` + ` ${otherProps.className ?? ""}`}>
        {label && (<label className={`${leftCol} col-form-label` }>
        {/* + (error ? " is-invalid" : " valid") */}
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel} {innerHtml}</small>)}
        </label>)}

        {content}
        
        
        {/* <div className="col-md-6 input-group">
            {(select && options.length > 0) ? (
                
            ) : (
                <div style={{width: small ? "50%" : "100%"}}>
                    {textarea ? (
                        <textarea disabled={disabled} ref={register} rows="8" type="textarea" placeholder={placeholder} name={name} className="form-control" />
                    ) : (
                        <div style={{width: small ? "50%" : "100%"}}>
                            {prepending && prepending.length > 0 && (
                                <div className="input-group-prepend">
                                    {prepending.map((val, idx) => {
                                        return (
                                            <div key={idx} className="input-group-text">{val}</div>
                                        )
                                    })}
                                </div>
                            )}
                            <input disabled={disabled} ref={register} type={type} placeholder={placeholder} name={name} className="form-control" />
                        </div>
                    )}
                </div>
                
            )}
            
        </div> */}

    </div>);
}

export default FormGroup
